import { ApplicationError } from './application-error';

/**
 * Error thrown when an upload operation fails.
 */
export class UploadError extends ApplicationError {
  public override readonly name: string;
  public readonly status?: number;

  constructor(message: string, status?: number) {
    super(message);
    this.name = 'UploadError';
    this.status = status;
  }
}
